<template>
  <WellModalContent 
    class="pt-10"
    @close="$attrs._close()"
    size="small"
  >
    <form class="flex flex-col gap-4" @submit.prevent="disableEventSubmit">
      <h3 class="text-lg font-bold">Deactivation feedback:</h3>
      <textarea
        name="www_admin_review_notes"
        v-model="wwwAdminReviewNotes"
        rows="6"
        class="w-full border border-dark rounded-md p-2"
        placeholder="Please provide feedback for why this event should be deactivated (at least 10 characters)"
      ></textarea>
      <div class="flex justify-end">
        <button class="button-dark-outlined" :disabled="!isValid || inProgress">Disable event</button>
      </div>
    </form>
  </WellModalContent>
</template>

<script lang="ts" setup>
import WellModalContent from '~/components/common/WellModalContent.vue'
import { useApi } from '@/composables/useApi'

const { disableEvent } = useApi() 

const props = defineProps<{
  event: EventResponse,
}>()

const attrs = useAttrs()

const inProgress = ref(false)

const isValid = computed(() => {
  return wwwAdminReviewNotes.value.length > 9
})

const disableEventSubmit = async () => {
  try {
    inProgress.value = true
    await disableEvent(props.event.id, wwwAdminReviewNotes.value)
    attrs._close()
  } catch (error) {
    console.error(error)
  } finally {
    inProgress.value = false
  }
}

const wwwAdminReviewNotes = ref('')

</script>